// Room names the server gives ("Stage 2", and "Stage 1" for the primary) are
// saved in English. Kept apart from rooms.js so components/globalUtils.js can
// use it without loading the rooms code.
import { t, tc } from "@/localization";

const NOUN_NAMES = {
  Room: () => tc("room noun", "Room"),
  Stage: () => tc("room noun", "Stage"),
  Track: () => tc("room noun", "Track"),
  Court: () => tc("room noun", "Court"),
  Field: () => tc("room noun", "Field"),
  Hall: () => tc("room noun", "Hall"),
  Camera: () => t("Camera"),
};

// A name the server gave ("Stage 2", "Camera") in the app's language. Names
// people typed are left as they are.
export const roomLabelText = (label) => {
  const match = /^(Room|Stage|Track|Court|Field|Hall|Camera)(?: (\d+))?$/.exec(
    label || ""
  );
  if (!match) return label;
  const noun = NOUN_NAMES[match[1]]();
  return match[2] ? t("{noun} {number}", { noun, number: match[2] }) : noun;
};
